import ServiceDetails from "../components/Service/ServiceDetails";
import Dashboard from "../screens/Auth/Dashboard";
import Profile from "../screens/Auth/Profile";
import Login from "../screens/NonAuth/Login";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import FAQ from "../screens/users/FAQ";
import Home from "../screens/users/Home";
import ProductList from "../screens/Auth/ProductList";
import IndustryList from "../screens/Auth/IndustryList";
import IndustryDetailPage from "../screens/users/Industrydetailpage";
import IndustriesPage from "../screens/users/Industriespage";
import ProductDetailPage from "../screens/users/Productdetailpage";
import NewProduct from "../components/AdminSideComponent/Products/Newproduct";
import ServiceList from "../screens/Auth/ServiceList";
import NewsList from "../screens/Auth/NewsList";
import NewsEvents from "../components/News/NewsEvents";
import NewsDetails from "../components/News/NewsDetails";
import ManageSeo from "../screens/Auth/ManageSeo";

export const authRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/products",
    component: <ProductList />,
  },
  {
    path: "/industries",
    component: <IndustryList />,
  },
  {
    path: "/services",
    component: <ServiceList />,
  },
  {
    path: "/news",
    component: <NewsList />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/seotags",
    component: <ManageSeo />,
  },
];

//Non Auth routes

export const nonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
];

// base user routes
export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/services/:slug",
    component: <ServiceDetails />,
  },
  {
    path: "/industries/:slug",
    component: <IndustryDetailPage />,
  },
  {
    path: "/industry",
    component: <IndustriesPage />,
  },
  {
    path: "/products/:slug",
    component: <ProductDetailPage />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/faq",
    component: <FAQ />,
  },
  {
    path: "/products/lead-story",
    component: <NewProduct />,
  },
  {
    path: "/events",
    component: <NewsEvents />,
  },
  {
    path: "/blogDetails/:id",
    component: <NewsDetails />,
  },
];
